import React from 'react';
import ChatList from '../ChatList';

// Sidebar de conversaciones: buscador de chats, chips de filtros aplicados y la
// lista paginada. La lógica (estado, carga, filtros, paginación) vive en el hook
// useChats; aquí solo se pinta lo que el mapa marca como compartido, recibido por
// props desde el Dashboard.
function ChatsPanel({
  chatFilters,
  setChatFilters,
  availableChannels,
  appliedChatFilters,
  chatsPagination,
  handleSearchChats,
  handleClearChatFilters,
  handleRemoveChatFilter,
  chats,
  selectedChat,
  handleChatSelect,
  loadMoreChats,
  botTimezonesMap,
}) {
  return (
    <>
      {/* Buscador de chats */}
      <div className="chat-search-bar">
        <div className="chat-search-row">
          <input
            type="text"
            className="chat-search-input"
            placeholder="Identificador"
            value={chatFilters.identificador}
            onChange={(e) => setChatFilters(f => ({ ...f, identificador: e.target.value }))}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSearchChats(); }}
          />
          <select
            className="chat-search-select"
            value={chatFilters.canal}
            onChange={(e) => setChatFilters(f => ({ ...f, canal: e.target.value }))}
            disabled={availableChannels.length === 0}
          >
            <option value="">Canal</option>
            {availableChannels.map(ch => (
              <option key={ch} value={ch}>
                {ch === 'whatsapp' ? 'WhatsApp'
                  : ch === 'telegram' ? 'Telegram'
                  : ch === 'instagram' ? 'Instagram'
                  : ch.charAt(0).toUpperCase() + ch.slice(1)}
              </option>
            ))}
          </select>
          <input
            type="text"
            className="chat-search-input"
            placeholder="Nombre"
            value={chatFilters.nombre}
            onChange={(e) => setChatFilters(f => ({ ...f, nombre: e.target.value }))}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSearchChats(); }}
          />
        </div>
        <div className="chat-search-actions">
          <button
            type="button"
            className="chat-search-btn primary"
            onClick={handleSearchChats}
            disabled={chatsPagination.isLoading}
          >
            Buscar
          </button>
          <button
            type="button"
            className="chat-search-btn"
            onClick={handleClearChatFilters}
            disabled={
              chatsPagination.isLoading ||
              (!appliedChatFilters.identificador && !appliedChatFilters.canal && !appliedChatFilters.nombre &&
               !chatFilters.identificador && !chatFilters.canal && !chatFilters.nombre)
            }
          >
            Limpiar
          </button>
        </div>
      </div>

      {/* Chips de filtros aplicados */}
      {(appliedChatFilters.identificador || appliedChatFilters.canal || appliedChatFilters.nombre) && (
        <div className="chat-filter-chips">
          <span className="chat-filter-chips-label">Filtros:</span>
          {appliedChatFilters.identificador && (
            <span className="chat-filter-chip">
              Identificador: {appliedChatFilters.identificador}
              <button
                type="button"
                className="chat-filter-chip-remove"
                aria-label="Quitar filtro de identificador"
                onClick={() => handleRemoveChatFilter('identificador')}
              >
                ×
              </button>
            </span>
          )}
          {appliedChatFilters.canal && (
            <span className="chat-filter-chip">
              Canal: {appliedChatFilters.canal.charAt(0).toUpperCase() + appliedChatFilters.canal.slice(1)}
              <button
                type="button"
                className="chat-filter-chip-remove"
                aria-label="Quitar filtro de canal"
                onClick={() => handleRemoveChatFilter('canal')}
              >
                ×
              </button>
            </span>
          )}
          {appliedChatFilters.nombre && (
            <span className="chat-filter-chip">
              Nombre: {appliedChatFilters.nombre}
              <button
                type="button"
                className="chat-filter-chip-remove"
                aria-label="Quitar filtro de nombre"
                onClick={() => handleRemoveChatFilter('nombre')}
              >
                ×
              </button>
            </span>
          )}
        </div>
      )}

      {/* Lista de chats con paginación */}
      <ChatList
        chats={chats}
        selectedChat={selectedChat}
        onChatSelect={handleChatSelect}
        onLoadMore={loadMoreChats}
        hasMore={chatsPagination.hasMore}
        isLoading={chatsPagination.isLoading}
        hasActiveFilters={!!(appliedChatFilters.identificador || appliedChatFilters.canal || appliedChatFilters.nombre)}
        onClearFilters={handleClearChatFilters}
        botTimezones={botTimezonesMap}
      />
    </>
  );
}

export default ChatsPanel;
